"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bulkResultSchema = exports.bulkTargetsSchema = exports.MAX_BULK_TARGETS = exports.bulkTargetSchema = void 0;
const zod_1 = require("zod");
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ ⚠️ ONE SHAPE FOR EVERY BULK ACTION. Item 72 of the 9 Sep 2026 feedback.   │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * *"Delete, change status, and whatever else each list's context allows. Today the only option is
 * Clear selection."* Five lists gain actions; one envelope means the screens report the outcome
 * the same way and one toast renders all of them.
 *
 * ⚠️⚠️ **THE VERSION TRAVELS WITH EVERY ID, AND DROPPING IT WOULD DISCARD THE STALE-WRITE GUARD
 * FOR EXACTLY THE OPERATION THAT NEEDS IT MOST.** CLAUDE.md §3: a mutable business table carries
 * `version` and a stale write is a `409`. A bulk edit acts on rows somebody has been LOOKING at —
 * a page loaded three minutes ago — so the odds that one of forty has moved underneath are far
 * better than for a single edit made in a dialog that was just opened. Sending `{ id }` alone
 * would silently overwrite a colleague's change on every row.
 *
 * ⚠️⚠️ **AND THE RESULT IS PER ROW, BECAUSE PARTIAL FAILURE IS THE NORMAL CASE HERE, NOT THE EDGE.**
 * Forty tasks, one of which somebody else has just closed; twelve clients, three of which still
 * have projects. An all-or-nothing bulk would refuse the whole selection over one row and leave the
 * person to find out which; a silent success would tell them thirty-nine of forty is forty.
 */
exports.bulkTargetSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    /** ⚠️ The version the SCREEN is showing. A row that has moved since is refused, not overwritten. */
    version: zod_1.z.number().int().nonnegative(),
});
/**
 * ⚠️ **Bounded at 200, matching `MAX_PAGE_SIZE`.** A selection cannot exceed what a page can show,
 * because that is where the selection is made — and an unbounded list of ids is an unbounded number
 * of transactions behind one request.
 */
exports.MAX_BULK_TARGETS = 200;
exports.bulkTargetsSchema = zod_1.z.array(exports.bulkTargetSchema).min(1).max(exports.MAX_BULK_TARGETS);
exports.bulkResultSchema = zod_1.z.object({
    /** The ids that changed. */
    done: zod_1.z.array(zod_1.z.string()),
    /**
     * The ids that did not, each with the code it would have been refused with on its own.
     *
     * ⚠️ **The SAME codes as the single-row path** — `conflict`, `permission_denied`, `not_found`,
     * `member_still_active`. Rule 5 says clients branch on `code`, and a bulk result inventing its
     * own vocabulary would be a second table for a screen to translate.
     */
    failed: zod_1.z.array(zod_1.z.object({ id: zod_1.z.string(), code: zod_1.z.string() })),
});
//# sourceMappingURL=bulk.js.map